import { Component, OnInit, EventEmitter } from '@angular/core';
import { GeneralFormComponent } from 'src/app/components/controls/general-form/general-form.component';
import { StaticData } from '../../../helpers/static-data';
import { DataTableComponent } from '../../controls/data-table/data-table.component';
import { FormGroup } from '@angular/forms';
import { Guid } from "guid-typescript";
import { ControlActions, TipoObjetoParaPermisos, ControllerMethods } from 'src/app/models/general.enum';

@Component({
  selector: 'app-consulta-external-pqrs',
  templateUrl: './consulta-external-pqrs.component.html',
  styleUrls: ['./consulta-external-pqrs.component.scss']
})
export class ConsultaExternalPqrsComponent extends GeneralFormComponent implements OnInit {

  FirstLoadDatatable: any = 0;
  DownloadPQR: any;
  DownloadPQRAnonimo: any;
  DownloadAnexos: any;
  DownloadAnexosAnonimo: any;
  DownloadAnexosRespuesta: any;
  DownloadAnexosRespuestaAnonimo: any;
  DownloadRespuesta: any;
  DownloadRespuestaAnonimo: any;
  CurrentItemGrid: any;
  Descargas: any;
  UserData: any;
  DatosUsuario: any;
  DatosIngreso: any;
  IdSolicitudRadicadoSalida: any;
  IdSolicitudPqrd: any;
  NumeroRadicado: any;
  BotonBuscar: any;
  BotonLimpiar: any;
  Meses: any = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Dicembre"];
  DivAnonim: any;
  DivLogged: any;
  GridViewExternalPQRs: any;
  GridViewExternalPQRsDetalle: any;
  

  public OnInitEnd() {
    debugger;
    /*this.PrimerNombre = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "PrimerNombre" });
    this.SegundoNombre = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "SegundoNombre" });
    this.PrimerApellido = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "PrimerApellido" });*/
    this.DownloadPQR = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DownloadPQR" });
    this.DownloadPQRAnonimo = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DownloadPQRAnonimo" });
    this.DownloadAnexos = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DownloadAnexos" });
    this.DownloadAnexosAnonimo = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DownloadAnexosAnonimo" });
    this.DownloadAnexosRespuesta = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DownloadAnexosRespuesta" });
    this.DownloadAnexosRespuestaAnonimo = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DownloadAnexosRespuestaAnonimo" });
    this.DownloadRespuesta = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DownloadRespuesta" });
    this.DownloadRespuestaAnonimo = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DownloadRespuestaAnonimo" });
    this.Descargas = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Descargas" });
    this.IdSolicitudRadicadoSalida = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "IdSolicitudRadicadoSalida" });
    this.IdSolicitudPqrd = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "IdSolicitudPqrd" });
    this.DivAnonim = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DivAnonim" });
    this.DivLogged = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "DivLogged" });
    this.NumeroRadicado = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "NumeroRadicado" });
    this.BotonBuscar = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Buscar" });
    this.BotonLimpiar = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Limpiar" });
    

    /*if ((StaticData.ExternalPqrContact == null || StaticData.ExternalPqrContact == undefined) && !StaticData.ExternalPqrAnonimo) {
      StaticData.ExternalPqrAnonimo = true;
    }
    else*/ if (StaticData.ExternalPqrContact != null && StaticData.ExternalPqrContact != undefined) {
      this.UserData = StaticData.ExternalPqrContact != undefined ? JSON.parse(StaticData.ExternalPqrContact) : StaticData.ExternalPqrContact;
      this.DatosUsuario = this.UserData.IdTipoContacto == 10 ? this.UserData.RazonSocial + ', ID ' + this.UserData.Identificacion : this.UserData.NombreCompleto + ', ID ' + this.UserData.Identificacion;
      let FechaIngreso = new Date();
      this.DatosIngreso = 'Fecha de ingreso a las ' + (FechaIngreso.getHours().toString().length == 1 ? '0' + FechaIngreso.getHours() : FechaIngreso.getHours()) + ":" + (FechaIngreso.getMinutes().toString().length == 1 ? '0' + FechaIngreso.getMinutes() : FechaIngreso.getMinutes()) + ', ' + FechaIngreso.getDate() + ' de ' + this.Meses[(FechaIngreso.getMonth())] + ', ' + FechaIngreso.getFullYear();
      this.NumeroRadicado.Hidden = true;
      this.BotonBuscar.Hidden = true;
      this.BotonLimpiar.Hidden = true;
    }
    else
    {
      this.NumeroRadicado.Hidden = false;
      this.BotonBuscar.Hidden = false;
      this.BotonLimpiar.Hidden = false;
    }
    this.SetModelToControls();

  }

  public AddComponentInstanceHandler(event) {
    debugger;
     if (event instanceof DataTableComponent) {
       if (event.name == 'GridViewExternalPQRs' || event.name == 'GridViewExternalPQRsDetalle') {
        if (StaticData.ExternalPqrContact != null && StaticData.ExternalPqrContact != undefined && event.name == 'GridViewExternalPQRs') {
         this.SetProcesando(true);
         event.QueryConfig.Entity.IdContacto = (StaticData.ExternalPqrContact != null ? JSON.parse(StaticData.ExternalPqrContact).IdContacto : 0);
         event.cargarGrilla = true;
         event.ReCargarGrilla();
         this.SetProcesando(false);
       }
      
       if (StaticData.ExternalPqrContact != null && StaticData.ExternalPqrContact != undefined && event.name == 'GridViewExternalPQRsDetalle') {
        this.SetProcesando(true);
        event.QueryConfig.Entity.IdSolicitudRadicadoSalida = 0
        event.QueryConfig.Entity.IdSolicitudPqrd = 1
        event.cargarGrilla = true;
        event.ReCargarGrilla();
        this.SetProcesando(false);
      }
       this.componentsContainer.Tables.push(event);
      }
 
     }
     else {
    super.AddComponentInstanceHandler(event);
    }
  }

  public OnActionEventHandler(event) {
    debugger;
    if (event.Name == "DownloadPQR") {

      this.modelo.modelo.DataAdd =
      {
        IdSolicitudPqrd: this.CurrentItemGrid.IdSolicitudPqrd
      };

      this.helperActions.ExecuteActionsControl((event.Option) ? event.Option : event.config,
        false, null, this.modelo, this.permissionsConfig,
        this, null, new EventEmitter<any>(), this.componentsContainer,
        event.Option, this.modelo.modeloMetadata, { importUrl: this.importUrl });

    }
    else if (event.Name == "DownloadPQRAnonimo") {

      this.modelo.modelo.DataAdd =
      {
        IdSolicitudPqrd: this.CurrentItemGrid.IdSolicitudPqrd
      };

      this.helperActions.ExecuteActionsControl((event.Option) ? event.Option : event.config,
        false, null, this.modelo, this.permissionsConfig,
        this, null, new EventEmitter<any>(), this.componentsContainer,
        event.Option, this.modelo.modeloMetadata, { importUrl: this.importUrl });

    }
    else if (event.Name == "DownloadAnexosRespuesta") {

      this.modelo.modelo.DataAdd =
      {
        IdSolicitudRadicadoSalida: this.CurrentItemGrid.IdSolicitudRadicadoSalida
      };

      this.helperActions.ExecuteActionsControl((event.Option) ? event.Option : event.config,
        false, null, this.modelo, this.permissionsConfig,
        this, null, new EventEmitter<any>(), this.componentsContainer,
        event.Option, this.modelo.modeloMetadata, { importUrl: this.importUrl });

    }
    else if (event.Name == "DownloadAnexosRespuestaAnonimo") {

      this.modelo.modelo.DataAdd =
      {
        IdSolicitudRadicadoSalida: this.CurrentItemGrid.IdSolicitudRadicadoSalida
      };

      this.helperActions.ExecuteActionsControl((event.Option) ? event.Option : event.config,
        false, null, this.modelo, this.permissionsConfig,
        this, null, new EventEmitter<any>(), this.componentsContainer,
        event.Option, this.modelo.modeloMetadata, { importUrl: this.importUrl });

    }
    else if (event.Name == "DownloadRespuesta") {

      this.modelo.modelo.DataAdd =
      {
        IdSolicitudRadicadoSalida: this.CurrentItemGrid.IdSolicitudRadicadoSalida
      };

      this.helperActions.ExecuteActionsControl((event.Option) ? event.Option : event.config,
        false, null, this.modelo, this.permissionsConfig,
        this, null, new EventEmitter<any>(), this.componentsContainer,
        event.Option, this.modelo.modeloMetadata, { importUrl: this.importUrl });

    }
    else if (event.Name == "DownloadRespuestaAnonimo") {

      this.modelo.modelo.DataAdd =
      {
        IdSolicitudRadicadoSalida: this.CurrentItemGrid.IdSolicitudRadicadoSalida
      };

      this.helperActions.ExecuteActionsControl((event.Option) ? event.Option : event.config,
        false, null, this.modelo, this.permissionsConfig,
        this, null, new EventEmitter<any>(), this.componentsContainer,
        event.Option, this.modelo.modeloMetadata, { importUrl: this.importUrl });

    }
    else if (event.Name == "DownloadAnexos") {
      debugger;
      this.modelo.modelo.IdSolicitudPqrd = this.CurrentItemGrid.IdSolicitudPqrd

      this.helperActions.ExecuteActionsControl((event.Option) ? event.Option : event.config,
        false, null, this.modelo, this.permissionsConfig,
        this, null, new EventEmitter<any>(), this.componentsContainer,
        event.Option, this.modelo.modeloMetadata, { importUrl: this.importUrl });

    }
    else if (event.Name == "DownloadAnexosAnonimo") {
      debugger;
      this.modelo.modelo.IdSolicitudPqrd = this.CurrentItemGrid.IdSolicitudPqrd

      this.helperActions.ExecuteActionsControl((event.Option) ? event.Option : event.config,
        false, null, this.modelo, this.permissionsConfig,
        this, null, new EventEmitter<any>(), this.componentsContainer,
        event.Option, this.modelo.modeloMetadata, { importUrl: this.importUrl });

    }
    else if (event.Name == "Buscar") {
        if(this.modelo.modelo.NumeroRadicado != '' && this.modelo.modelo.NumeroRadicado != undefined)
        {
          this.SetProcesando(true);
          this.GridViewExternalPQRs = this.componentsContainer.Tables.find(x => { return x.name == "GridViewExternalPQRs"; });
          this.GridViewExternalPQRs.QueryConfig.Entity.NumeroRadicado = this.modelo.modelo.NumeroRadicado;
          this.GridViewExternalPQRs.cargarGrilla = true;
          this.GridViewExternalPQRs.ReCargarGrilla();
          this.SetProcesando(false);
        }
    }
    else if (event.Name == "Limpiar") {
        this.DivAnonim.Hidden = true;
        this.DownloadAnexosRespuestaAnonimo.Hidden = true;
        this.DownloadRespuestaAnonimo.Hidden = true;
        this.SetProcesando(true);
        this.GridViewExternalPQRs = this.componentsContainer.Tables.find(x => { return x.name == "GridViewExternalPQRs"; });
        this.GridViewExternalPQRs.QueryConfig.Entity.NumeroRadicado = '1';
        this.GridViewExternalPQRs.cargarGrilla = true;
        this.GridViewExternalPQRs.ReCargarGrilla();
        this.GridViewExternalPQRsDetalle = this.componentsContainer.Tables.find(x => { return x.name == "GridViewExternalPQRsDetalle"; });
        //this.GridViewExternalPQRsDetalle.QueryConfig.Entity.NumeroRadicado = '1';
        this.GridViewExternalPQRsDetalle.cargarGrilla = true;
        if (this.GridViewExternalPQRsDetalle.QueryConfig.Entity.IdSolicitudPqrd){
          this.GridViewExternalPQRsDetalle.ReCargarGrilla();
        }
        this.SetProcesando(false);
        this.modelo.modelo.NumeroRadicado = '';
         this.SetModelToControls();
    }
    else
      super.OnActionEventHandler(event);
  }

  public OnDataTableEditHandler(event) {
    debugger;
    if (event.name == 'GridViewExternalPQRs') {

      this.componentsContainer.ReloadTable('GridViewExternalPQRsDetalle', { IdSolicitudPqrd: -1, IdSolicitudRadicadoSalida:  -1})
      this.CurrentItemGrid = event.modelo.currentItem;
      this.IdSolicitudRadicadoSalida = this.CurrentItemGrid.IdSolicitudRadicadoSalida;
      this.IdSolicitudPqrd = this.CurrentItemGrid.IdSolicitudPqrd;

      //if (StaticData.ExternalPqrContact == null || StaticData.ExternalPqrContact == undefined) {
      if (this.CurrentItemGrid.EsAnonima) {
        this.DivLogged.Hidden = true;
        this.DivAnonim.Hidden = false;
        if (this.CurrentItemGrid.IdSolicitudRadicadoSalida != null && this.CurrentItemGrid.IdSolicitudRadicadoSalida != undefined && this.CurrentItemGrid.IdSolicitudRadicadoSalida != "") {
          if (this.CurrentItemGrid.EstadoSalida == 5) {
            this.DownloadAnexosRespuestaAnonimo.Hidden = false;
            this.DownloadRespuestaAnonimo.Hidden = false;
          }
          else {
            this.DownloadAnexosRespuestaAnonimo.Hidden = true;
            this.DownloadRespuestaAnonimo.Hidden = true;
          }
        }
        else {
          this.DownloadAnexosRespuestaAnonimo.Hidden = true;
          this.DownloadRespuestaAnonimo.Hidden = true;
        }
      }
      else {

        this.DivLogged.Hidden = false;
        this.DivAnonim.Hidden = true;
        if (this.CurrentItemGrid.IdSolicitudRadicadoSalida != null && this.CurrentItemGrid.IdSolicitudRadicadoSalida != undefined && this.CurrentItemGrid.IdSolicitudRadicadoSalida != "") {
          if (this.CurrentItemGrid.EstadoSalida == 5) 
          {
            this.DownloadAnexosRespuesta.Hidden = false;
            this.DownloadRespuesta.Hidden = false;
          }
          else {
            this.DownloadAnexosRespuesta.Hidden = true;
            this.DownloadRespuesta.Hidden = true;
          }

        }
        else {
          this.DownloadAnexosRespuesta.Hidden = true;
          this.DownloadRespuesta.Hidden = true;
        }
      }

      this.Descargas.Hidden = false;

    }

  }

  public OnLoadGridHandler(event) {
    debugger;
    if (event.controlName == 'GridViewExternalPQRs') {
      this.FirstLoadDatatable += 1;
      if (this.FirstLoadDatatable >= 2) {
        //this.componentsContainer.ReloadTable('GridViewExternalPQRsDetalle', { IdSolicitudPqrd: -1, IdSolicitudRadicadoSalida:  -1});
      this.DivLogged.Hidden = true;
      this.DivAnonim.Hidden = true;
      this.Descargas.Hidden = true;
        //if (event.data.length == 0) {
          //this.utility.VerModalWarning({ "titulo": "Advertencia", "descripcion": "La consulta realizada no obtuvo resultados, recuerde ingresar los datos de acuerdo a las instrucciones de consulta de la parte superior" });
        //}
      }
    }
    if (event.controlName == 'GridViewExternalPQRsDetalle' && this.componentsContainer.Tables.find(x => { return x.name == "GridViewExternalPQRsDetalle" }) ){
      if(this.modelo.currentItem.IdSolicitudPqrd !== ''){
        this.GridViewExternalPQRsDetalle = this.componentsContainer.Tables.find(x => { return x.name == "GridViewExternalPQRsDetalle"; })
        this.GridViewExternalPQRsDetalle.IdSolicitudPqrd = this.modelo.currentItem.IdSolicitudPqrd
        this.GridViewExternalPQRsDetalle.IdSolicitudRadicadoSalida = this.modelo.currentItem.IdSolicitudRadicadoSalida
        this.SetProcesando(false);
      }
      else{
        this.GridViewExternalPQRsDetalle = this.componentsContainer.Tables.find(x => { return x.name == "GridViewExternalPQRsDetalle"; })
        this.GridViewExternalPQRsDetalle.IdSolicitudPqrd = 1
        this.GridViewExternalPQRsDetalle.IdSolicitudRadicadoSalida = 0
        
        this.SetProcesando(false);
      }
      
    }

  }

  SalidaPqrs($event) {
    debugger;
    this.LimpiarSesion();
  }

  public LimpiarSesion() {
    debugger;

    this.DatosUsuario = null;
    this.DatosIngreso = null;
    var CurrentUrl = window.location.href;
    StaticData.ContactAuthenticated = false;
    window.location.href = CurrentUrl.replace('ConsultaExternalPQR', 'HomeExternalPQR');
  }

}
